import './CardThree.scss';

function CardThree() {
  return (
    <section className="CardThree">
      <div className="CardThree_img"></div>
      <h3 className="CardThree_title">Mamadou Niakaté</h3>
      <div className="CardThree_text">
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
      </div>
    </section>
  );
}

export default CardThree;